import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { Subscription, fromEvent } from 'rxjs';
import { AuthentificationService } from "../services/authentification-service.service";
import { MatDialog } from '@angular/material/dialog';
import { StreetViewMapComponent } from '../street-view-map/street-view-map.component';
import { UserService } from '../services/user.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { HpService } from '../services/hp.service';
import { WizardHpBaseComponent } from '../base/wizard/wizard-hp-base-component';
import 'hammerjs';
import * as Hammer from 'hammerjs';
//declare function matomo(): void;
//const url_images = "/assets/images/ambiances/miniature";
//const upload_icon = "https://simulateur.simuleo.com/default-simulateur/assets/images/icons/upload-icon.png";
@Component({
  selector: 'app-maisons',
  templateUrl: './maisons.component.html',
  styleUrls: ['./maisons.component.scss']
})
export class MaisonsComponent extends WizardHpBaseComponent implements OnInit {
  @ViewChild('scrollContent', { static: false }) scrollContainer: ElementRef;
  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;
  @Input() elementCurrent: string;
  @Input() viewExt: string;
  @Input() viewInt: string;
  @Input() view: string;
  @Input() viewMap: string;
  @Output() emitView = new EventEmitter<string>();
  @Output() emitHasuploadExt = new EventEmitter<boolean>();
  @Output() emitHasuploadInt = new EventEmitter<boolean>();
  @Output() emitImageUploadExt = new EventEmitter<string>();

  fileUpload_name = "Votre image jpg, png";
  fileUpload_photo = "assets/images/icons/upload-icon.png";
  images = [];
  imgSelected = false;
  imgUpload_selected = false;
  idImg: string;
  etape_show = false;
  dataMap: any
  dialogDataView = [];
  couleur_1 = "#56565A";
  couleur_2: "#C0B800";
  format_fichier = true;
  isMobile = false;
  readerFile: any;
  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  deviceMobile = false;
  mobileImages: any;
  ambianceData: any;
  indexImage = 0;
  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService,
    public dialog: MatDialog, router: Router,
    public observer: BreakpointObserver) {
    super(chgDetectorRef, hpService, router);

    //this.location.replaceState('/' + this.getHpService().getRoute_path());

    this.getHpService().setHeaderIn(true);
    this.getHpService().setCurrentPage(this.getIndexNextUrl('selecteur-maisons'))
    this.getHpService().setEtape_final(false);
    this.images = this.getHpService().getGallery();
    this.mobileImages = this.getHpService().getAmbiancesView("0");
    this.couleur_1 = this.getHpService().getConfig().default_couleur;
    this.couleur_2 = this.getHpService().getConfig().active_couleur;
    this.getHpService().setView("0")
    this.getHpService().setTypeVisuel('view-0');
    this.getHpService().setStatut_user(true);
    this.getHpService().emitDataChange();
   /* switch(this.getHpService().getConfig().herculepro.slug)
    {
      case "janneau":
                    matomo();
                    break;
    }*/
  }

  ngOnInit() {
    // super.ngOnInit();
    this.observer.observe(['(max-width: 700px)']).subscribe((res) => {
      if (res.matches) {
        this.isMobile = true;


      }
    });
    this.dataMap = this.getHpService().getConfig().data_googleMap.data;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => {

      switch (true) {
        case window.innerWidth < 700:
          {
            this.deviceMobile = true;
            break;
          }
        default:
          this.deviceMobile = false;

      }
    });
    this.initHammerjs();
  }


  onFileChange(event) {
    this.format_fichier = true;
    this.getHpService().setView("0");
    this.readerFile = new FileReader();

    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      if (file.type !== "image/png" && file.type !== "image/jpeg") {
        this.format_fichier = false;
        this.fileUpload_name = "Votre image jpg, png";
        this.fileUpload_photo = "assets/images/icons/upload-icon.png";
        this.getHpService().setTypeVisuel('view-0');
        this.getHpService().emitDataChange();
        return;
      }
      this.fileUpload_name = file.name;
      this.readerFile.readAsDataURL(file);
      this.readerFile.onload = () => {

        this.fileUpload_photo = this.readerFile.result.toString();
        this.imgSelected = false;
        this.imgUpload_selected = true;
        this.emitHasuploadExt.emit(true);
        this.emitView.emit(this.readerFile.result.toString());
        this.idImg = "id";
        this.getHpService().setIsUploadExt(true);
        this.getHpService().setImageName(this.readerFile.result.toString());
        this.getHpService().setTypeVisuel('upload-0'),
          this.dataMap = {
            "visible": 0,
            "linkposition": "46.98123233164222,1.805750207787383",
            "heading": 108.76767031965346,
            "pitch": 2.8858925347222737,
            "fov": 159
          };
        this.getHpService().emitDataChange();

        //this.toNextLink();
        if (this.isMobile) {
          this.toNextLink();
        }
        // this.toNextLink();

      };

    }


  }

  removeImgUploadMap() {
    this.fileUploader.nativeElement.value = null;
    this.imgUpload_selected = false;
    this.getHpService().setTypeVisuel('view-0'),
      this.fileUpload_photo = "assets/images/icons/upload-icon.png";
    this.fileUpload_name = "Votre image jpg, png";
    this.dataMap = {
      "visible": 0,
      "linkposition": "46.98123233164222,1.805750207787383",
      "heading": 108.76767031965346,
      "pitch": 2.8858925347222737,
      "fov": 159
    };
    this.getHpService().setIsUploadExt(false);
    this.getHpService().setImageName(this.getHpService().getImageName('0'));

  }



  setView(id: string) {
    this.getHpService().emitDataChange();
    this.getHpService().setView("0");
    this.idImg = id;
    this.imgSelected = true;
    this.imgUpload_selected = false;
    this.fileUpload_name = "Votre image jpg, png";
    this.fileUpload_photo = this.getHpService().getAssetsPath() + "/assets/images/ambiances/miniature";
    this.getHpService().setIsUploadExt(false);
    this.getHpService().setImageName(id);
    this.getHpService().setTypeVisuel('view-0')
    this.getHpService().emitDataChange();
    this.toNextLink();
  }

  scrollLeft() {
    let scrollContainer = document.getElementById('scrollContent') as HTMLInputElement;
    scrollContainer.scrollLeft -= 150;//= ({behavior: 'smooth'});


  }
  scrollRight() {
    this.scrollContainer.nativeElement.scrollLeft += 150;
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  prevEtape() {

    this.idImg = "";
    this.imgSelected = false;
    this.imgUpload_selected = false;
    this.fileUpload_name = "Votre Image jpg, png";
    //this.fileUpload_photo = fileUpload_photo;

  }


  getViewMiniature(id: string) {

    return "plgnd-sample-min-" + id + ".png";
  }

  getClasseImageActive(view): string {
    return view ? "overlay-backdrop-maison" : "no-overlay-backdrop-maison";
  }


  getIndexFlex(id): number {
    return id === 0 ? 0 : id * 3;
  }


  openDialogMap() {
    const dialogRef = this.dialog.open(StreetViewMapComponent, {
      panelClass: 'dialog-map', disableClose: true,
      data: { name: "googleMap" }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.dataMap = (this.getHpService().getTypeVisuel('0') === 'googleMap') ? this.getHpService().getDataMap() : this.dataMap;
      this.format_fichier = true;
      console.log(this.getHpService().getTypeVisuel('0'))
      if (this.dataMap.visible === 1) {
        this.fileUploader.nativeElement.value = null;
      }
      this.fileUpload_photo = (this.dataMap.visible === 1) ? "https://maps.googleapis.com/maps/api/streetview?size=640x360&location=" +
        this.dataMap.linkposition + "&heading=" + this.dataMap.heading + "&fov=" +
        this.dataMap.fov + "&pitch=" + this.dataMap.pitch + "&key="+this.getHpService().getConfig().data_googleMap.key : this.fileUpload_photo;
      this.fileUpload_name = (this.dataMap.visible === 1) ? "" : this.fileUpload_name;
      this.getHpService().setTypeVisuel('googleMap');
      this.getHpService().setStatutMatButton(false);
      this.getChangeDetectorRef().detectChanges();
      this.getHpService().emitDataChange();

      if (this.dataMap.visible === 1 && this.isMobile) {
        this.toNextLink();
      }
      {
        //this.toNextLink();
      }



    });

  }
  getVisual_type() {
    return this.getHpService().getVisual_type();
  }
  getClasses(id, id_current): string {
    return id === id_current ? "pic-showed" : "item-hidden";
  }
  mobileScrollLeft() {
    let next_index = this.indexImage + 1;
    let prev_index = this.indexImage;
    this.indexImage++;
    if (this.indexImage > this.mobileImages.length - 1) {
      this.indexImage = 0;
      next_index = 0;
      prev_index = this.mobileImages.length - 1;
    }


    let prev_imgId = document.getElementById('image-' + prev_index) as HTMLInputElement;
    let next_imgId = document.getElementById('image-' + next_index) as HTMLInputElement;
    prev_imgId.style.left = "-200%";
    next_imgId.style.left = "0";
    prev_imgId.style.zIndex = "1";
    next_imgId.style.zIndex = "100";
  }
  mobileScrollRight() {
    console.log(this.indexImage)
    var next_index = this.indexImage;//0
    var prev_index = this.indexImage - 1;
    this.indexImage--;
    if (this.indexImage < 0) {
      this.indexImage = this.mobileImages.length - 1;
      prev_index = this.mobileImages.length - 1;
      next_index = 0;
    }
    let prev_imgId = document.getElementById('image-' + prev_index) as HTMLInputElement;
    let next_imgId = document.getElementById('image-' + next_index) as HTMLInputElement;
    prev_imgId.style.left = "0";
    prev_imgId.style.zIndex = "100"
    next_imgId.style.left = "200%";
    //this.indexImage = this.indexImage >= 0 ? this.indexImage : this.mobileImages.length -1;
  }
  initHammerjs() {
    var pic = document.getElementById("picter-swipe");

    var hammertimeLeft = new Hammer.Manager(pic, {
      recognizers: [
        [Hammer.Swipe, {
          direction: Hammer.DIRECTION_LEFT
        }]
      ]
    });
    let me = this;
    hammertimeLeft.on("swipe", function (ev) {
     
      me.mobileScrollRight();
    });

    var hammertimeRight = new Hammer.Manager(pic, {
      recognizers: [
        [Hammer.Swipe, {
          direction: Hammer.DIRECTION_RIGHT
        }]
      ]
    });

    hammertimeRight.on("swipe", function (ev) {
      me.mobileScrollLeft();

    });

  }

}
